// Semantic column slots for the entity display framework.
//
// Every column an entity declares maps a data field to ONE slot. Slots give
// columns a semantic role (not just a position) so the same entity config can
// drive a table, a compact preview, or a grid card by picking which slots show.
//
//   primary  — the thing you navigate to (name/title); usually a link
//   context  — parent / scope (the place a quest belongs to, the campaign's advertiser)
//   status   — state badges (active/pending/flagged)
//   metadata — supplementary scalars (points, counts, type)
//   temporal — dates (created/updated)

export const SLOTS = {
  PRIMARY: 'primary',
  CONTEXT: 'context',
  STATUS: 'status',
  METADATA: 'metadata',
  TEMPORAL: 'temporal'
}

export const SLOT_ORDER = [SLOTS.PRIMARY, SLOTS.CONTEXT, SLOTS.STATUS, SLOTS.METADATA, SLOTS.TEMPORAL]

// Default header label per slot when a column doesn't set `label`.
export const SLOT_HEADERS = {
  [SLOTS.PRIMARY]: 'Name',
  [SLOTS.CONTEXT]: '',
  [SLOTS.STATUS]: 'Status',
  [SLOTS.METADATA]: '',
  [SLOTS.TEMPORAL]: ''
}

// Resolve a dot-path key ("place.name") against a row, safely. Keys only — the
// server sends display-ready values, so configs never carry functions.
export function resolveField(row, path) {
  return String(path).split('.').reduce((acc, key) => (acc != null && typeof acc === 'object' ? acc[key] : undefined), row)
}

const sortBySlot = (cols) => [...cols].sort((a, b) => SLOT_ORDER.indexOf(a.slot) - SLOT_ORDER.indexOf(b.slot))

// Columns to show for a density preset. `full` = every column in slot order;
// `compact` = only the slots the entity's `compact.show` allows.
export function columnsForDensity(config, density) {
  if (density !== 'compact' || !config.compact) return sortBySlot(config.columns)
  const allowed = new Set(config.compact.show)
  return sortBySlot(config.columns.filter((c) => allowed.has(c.slot)))
}

// Columns to show in grid cards (entity.grid.show), in slot order.
export function columnsForGrid(config) {
  if (!config.grid) return []
  const allowed = new Set(config.grid.show)
  return sortBySlot(config.columns.filter((c) => allowed.has(c.slot)))
}

export function headerLabel(column) {
  return column.label ?? SLOT_HEADERS[column.slot] ?? ''
}
